export default __webpack_public_path__ + "static/perpetua-io-ogimage-ES-cc99e950951c67b931112e8d043c6d61.png";